import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPISiteFloors {
    // This method creates a new floor in an existing site.
    // The boundary response property is computed from the floorplan geojson submitted in the request.
    createNewSiteFloor(siteID, params) {
        return fetchJSON(`/sites/${siteID}/floors`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method updates a floor in an existing site.
    updateSiteFloor(siteID, floorID, params) {
        return fetchJSON(`/sites/${siteID}/floors/${floorID}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes a site floor by its ID.
    deleteSiteFloor(siteID, floorID) {
        return fetchWithAuth(`/sites/${siteID}/floors/${floorID}`, {
            method: "DELETE",
        });
    }
    //This method deletes a floorplan image
    deleteFloorplanImage(siteID, floorID) {
        return fetchWithAuth(`/sites/${siteID}/floors/${floorID}/image`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-site-floors.js.map